import React, { useEffect, useState, useRef } from 'react';
import './index.css';
// import { useInView } from 'react-intersection-observer';
import LcIconLink, { Size, Position } from '../../Generic/LcIconLink';
import LcDropDown from '../../Generic/LcDropDown';
import Parse from 'html-react-parser';
import { OptionsTooltips } from '../../../models/OptionsTooltips';
import LcIcon from '../../Generic/LcIcon';
import HHDetailTooltip from '../../Generic/HHDetailTooltip';
import {
    Menu,
    MenuItem,
    SubMenu,
    MenuDivider,
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import DynamicTableGroupColumnManagerService from "../../../services/DynamicTableGroupAndColumnBuilder/DynamicTableGroupAndColumnBuilder"
import moment from 'moment';
import Modal from '../../Dialog/Modal';
import imgLegend from '../../../assets/images/legenda.png'
import { SolicitationView } from '../../../models/SolicitationView';
import { MenuState } from '../../../store/reducers/menuReducer';
import { PrefState } from '../../../store/reducers/prefReducer';
import { RootState } from '../../../store/index';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextTools from "../../../services/TextTools/TextTools";
import BodyGroup from './BodyGroup';
import ProcessService from '../../../services/ProcessService/ProcessService';
import { Field } from "../../../models/Field";
import { Period } from "../../../models/Period";
import { escapeRegExp } from 'lodash';
import AttendanceFilters from './AttendanceFilters';
import LcTooltip from '../../Generic/LcTooltip';
import ExportList from '../../Form/ExportList';
import InputLink from './InputLink';

//Campos do Filtrokendo-react-dropdowns
interface FilterField {
    label: string,
    name: string,
    type: string,
    value?: string,
    options?: any[],
    show?: boolean,
}

//Objeto do Filtro
interface FilterData {
    fields: FilterField[],
    onChange: Function
}

interface Sort {
    column: string,
    direction: string
}

type FontSize = 'tiny' | 'small' | 'medium' | 'large' | 'big';

interface Column {
    nameBusinessArea: boolean,
    subject: boolean,
    workName: boolean,
    nameResponsibleUser: boolean,
    nameClassification: boolean,
    workStatus: boolean,
    idStatus: boolean,
    statusIcon: boolean,
    registrationDate: boolean,
    endDate: boolean,
    nameCustomer: boolean,
    workGroupName: boolean,
    nameClassificationGroup: boolean,
    nameServiceGroup: boolean,
    nameOpenMode: boolean,
    urgency: boolean,
    nameProcess: boolean,
    nameService: boolean,
    slaResponseDate: boolean,
    slaSolutionDate: boolean,
    sla_slo: boolean,
    id: boolean,
    nameUserRequester: boolean,
    workType: boolean,
    businessUnitDescription: boolean,
    slaDescription: boolean,
    workDateBegin: boolean,
    workDateEnd: boolean,
    workDateRegister: boolean,
}

interface Props {
    loading?: boolean,
    rows: object[],
    rowClick?: {
        rowPointer: boolean,
        rowFunction: Function,
    },
    columns: {
        field: string,
        headerName: string,
        width: string,
        // width: "15%", 
        align: string,
        hide?: boolean,
        renderCell?: Function
    }[],
    tootipPropeties?: {
        montaFields: Function,
        searchExpandedFields: Function,
        optionsProprities: OptionsTooltips
    },
    functions?: {
        icon: string,
        tooltip?: string,
        func: Function,
        disabled?: boolean
    }[],
    functionGeneric: {
        changeColorAfterClick?: boolean;
        id?: string;
        icon: string,
        iconDisabled?: {
            color: string,
            tooltip: string,
            disabled?: boolean
        },
        tooltip?: string,
        badge?: { number: number, status: string },
        func?: Function,
        disabled?: boolean,
        size?: Size,
        isSelection?: boolean,
        selection?: {
            contents: any[],
            onChange: Function
        },
        isVincular?: boolean,
        isFilter?: boolean,
        tooltipPosition?: Position,
        isFilterCampo?: {
            isLoadingContents: boolean,
            contents: Period[],
            onChange: Function,
            onChangePesquisa: Function,
            dropDownOptions: Field[],
            onClickOption: Function
        },
        activedAfterClick?: boolean
    }[],
    functionsRow?: {
        label: string,
        func: Function,
        disabled?: Function,
        hidden?: Function
    }[],

    loadMore?: Function,
    size: number, //Tamanho total dos dados retornado pela API
    height?: string,
    fontSize?: FontSize,
    onSortChange?: Function,
    onSelectChange?: Function,
    onRadioChange?: Function,
    filter?: FilterData,
    status?: Function,
    manufacturerUpdatedAt?: string,
    handleGroup: Function,
    handleRedefine: Function,
    optionsGroupBy: any[],
    grouperList: any[],
    handleOpen: Function,
    optionsGroups: any[],
    handleSelectColumns: Function,
    selectedGroups: any,
    handleSelectionGroups: Function,
    handleOptionColumns: Function,
    optionColumns: Column,
    openFilters: boolean,
    openModalVincular: boolean,
    handleFilters: Function,
    handleClearFilters: Function,
    handleOpenFilter: Function,
    handleSelectRow: Function,
    currentFilter: any,
    handleSelectedRows: Function,
    handleReload?: Function
    defaultRows: SolicitationView[],
    messageErrorGroup: string,
    cleanMessageError: Function,
    handleClear: Function,
    filterDefault: any,
}

const HHAttendantTable: React.FC<Props> = (props) => {
    // const { ref, inView } = useInView({});
    const processService = new ProcessService(props);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const [clientHeight, setClientHeight] = useState<number>(0);
    // const [filter, setFilter] = useState<FilterField[] | undefined>(props.filter?.fields);
    const [asFilter, setAsFilter] = useState<boolean>(false);
    const [modalFilterVisible, setModalFilterVisible] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<object[]>([]);
    const [sort, setSort] = useState<Sort>();
    const [selection, setSelection] = useState<Period>();
    const [dropDown, setDropDown] = useState<boolean>(true);
    const [options, setOptions] = useState<Field[]>([]);
    const [selectedRadioRows, setSelectedRadioRows] = useState<any[]>([]);
    // const selectedGroupsDefault = { assunto: false, solicitante: false, atendente: false, data: false, status: false };
    const dynamicTableService = new DynamicTableGroupColumnManagerService();
    const [onVisibleModalVinculo, setOnVisibleModalVinculo] = useState<boolean>(false);
    const [onModalLegend, setOnModalLegend] = useState<boolean>(false);
    const [dateReload, setDateReload] = useState<any>(undefined);
    const [densitySelected, setDensitySelected] = useState<string>("defaultdensity");
    const [tooltipData, setTooltipData] = useState<any>()
    const history = useHistory();
    // const solicitationService = new SolicitationService(props);
    const textTools = new TextTools();
    const dispatch = useDispatch();
    const [expandCloseAll, setExpandCloseAll] = useState<{ expand: boolean, close: boolean }>(
        (pref.data?.expandCloseAll)
            ? pref.data?.expandCloseAll
            : { expand: false, close: false }
    );

    useEffect(() => {
        setExpandCloseAll((pref.data?.expandCloseAll)
            ? pref.data?.expandCloseAll
            : { expand: false, close: false }
        );
    }, [pref.data?.expandCloseAll])

    const getWindowSize = () => {
        const { innerHeight } = window;
        return innerHeight;
    }

    const [windowHeight, setWindowHeight] = useState<number>(getWindowSize());

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowHeight(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    useEffect(() => {
        loadInitDensitySelected();
    }, [])

    const loadInitDensitySelected = async () => {
        props.functionGeneric.map(field => {
            let selectedTemp = field.isFilterCampo?.dropDownOptions;

            if (selectedTemp !== undefined) setOptions(selectedTemp);
        });
    }

    useEffect(() => {
        let el = document.getElementById('lcdti');
        let defaultRowHeight = 31;

        if (el) {
            let rows = Math.floor((el.clientHeight - 60) / defaultRowHeight);
            setClientHeight(rows)
            props.loadMore && props.loadMore(rows);
        }
    }, [document.getElementById('lcdti')])

    const templateMais: Period = {
        label: "mais",
        text: "mais",
        fields: [{
            name: "mais",
            value: "mais"
        }]
    };

    const templateHelper: Period[] = [
        {
            label: "Teste de Template",
            text: "Teste de Template",
            fields: [{
                name: "Teste de Template",
                value: "Teste de Template"
            }]
        }
    ]

    const handleSort = (column: string) => {
        (!sort || sort.column !== column)
            ? setSort({ column, direction: 'asc' })
            : setSort({ ...sort, direction: sort.direction === 'asc' ? 'desc' : 'asc' })
    }

    useEffect(() => {
        if (props.onSortChange && sort) {
            props.onSortChange({ sort, size: clientHeight });
        }
    }, [sort]);

    useEffect(() => {
        props.onSelectChange &&
            props.onSelectChange(selectedRows);
    }, [selectedRows]);

    useEffect(() => {
        props.onRadioChange &&
            props.onRadioChange(selectedRadioRows);
    }, [selectedRadioRows]);

    const getStatusRow = (status: string) => {
        const statusMap: { [key: string]: string } = {
            'primary': '#141b4d',
            'secondary': '#1b3a7a',
            'danger': '#e64646',
            'success': '#a5bf3e',
            'warning': '#ffb800',
            'link': '#0580ce'
        };

        return statusMap[status] || status;
    };

    const onChangeSelection = (selection: any) => {
        props.functionGeneric.map(teste => {
            teste.selection?.onChange(selection);
        })
    }

    const onChangeSelectionFilter = (selection: Period) => {
        setSelection(selection);
        props.functionGeneric.map(teste => {
            teste.isFilterCampo?.onChange(selection, searchInput.current.defaultValue);
        })
    }

    const [search, setSearch] = useState<string>("");

    const searchValue = (e: any) => {
        if (e.target.value !== "") {
            setSelection(undefined);

            props.functionGeneric.map(teste => {
                teste.isFilterCampo?.onChangePesquisa(e.target.value);
            })
        }

        setSearch(e.target.value);
    }

    const [selectedRowId, setSelectedRowId] = useState<any>();

    const searchInput = useRef<any>(null);

    useEffect(() => {
        if (dropDown === false) {
            searchInput.current.focus();
        }
        else {
            setSearch("");
        }
    }, [dropDown]);

    useEffect(() => {
        setSelectedRadioRows(selectedRadioRows);
        props.handleSelectedRows(selectedRadioRows);
    }, [selectedRadioRows]);

    const handleRowClick = (row: any, iCol: number, event) => {
        if ((iCol !== 0 && !event.ctrlKey && selectedRadioRows.length === 0) ||
            event.target.className.includes('ppi') ||
            event.target.className.includes('lciconlink')) {
            return;
        }
        else {
            let filter = selectedRadioRows.find(filtro => {
                return filtro.id === row.id;
            });

            functionRadio(row);

            if (filter) {
                let newRow = selectedRadioRows.filter(fil => fil.id !== row.id);
                setSelectedRadioRows(newRow);
            }
            else {
                setSelectedRadioRows(arr => [...arr, row]);
            }
        }
    }

    const [mousePosition, setMousePosition] = useState<{ x: number, y: number }>({ x: 0, y: 0 });
    const [hideTooltip, setHideTooltip] = useState<boolean>(true);

    const handleMouseMove = (event: any, rowId: number, iCol: number) => {
        if ((event.target.className === 'lcicon' || event.target.className.includes("ppi") || iCol >= 4)) {
            setHideTooltip(true);
        }
        else {
            setHideTooltip(false);
            setMousePosition({ x: event.pageX, y: event.pageY });
            setSelectedRowId(rowId);
            setTooltipData(props.tootipPropeties?.montaFields(rowId));
        }
    }

    useEffect(() => {
        if (menu.showHelper) {
            const openTooltipAttPref = pref.dataLocal?.openTooltipAttPref ?? false;

            if (openTooltipAttPref) {
                setHideTooltip(false);
                setMousePosition({ x: 334, y: 173 });
                setSelectedRowId(123456);
                setTooltipData(props.tootipPropeties?.montaFields(123456));
            }
        }
    }, [pref.dataLocal?.openTooltipAttPref])


    const [groupBy, setGroupBy] = useState<string>("");
    const [groups, setGroups] = useState<string[]>([]);

    const handleGroup = (group: string) => {
        let coluna: string = group;

        if (coluna !== "ungrouped") {
            const selectedGroups = {
                ...props.selectedGroups,
                [group]: !props.selectedGroups[group],
                ungrouped: false
            };

            props.handleSelectionGroups(selectedGroups);

            if (coluna === "statusIcon") {
                coluna = "idStatus";
            }

            if (groupBy === coluna) {
                setGroupBy("");
            }
            else {
                setGroupBy(coluna);
            }

            if (groups.includes(coluna)) {
                let listaTemp = groups.filter(x => x !== coluna);
                setGroups(listaTemp);
            }
            else {
                setGroups([...groups, coluna]);
            }

            props.handleGroup(coluna);
        }
        else {
            const selectedGroups = { ...props.selectedGroups, [group]: true };
            props.handleSelectionGroups(selectedGroups);
            handleUnGroupVisible();
        }
    }

    useEffect(() => {
        if (props.rows && props.rows.length > 0) {
            setDateReload(new Date());
        }
    }, [props.rows])

    const tooltipObject = {
        fields: tooltipData,
        searchExpandedFields: props.tootipPropeties?.searchExpandedFields,
        rowId: selectedRowId,
        mousePosition: mousePosition,
        hide: hideTooltip,
        tootipPropetiesOptions: props.tootipPropeties?.optionsProprities
    }

    const handleUngroup = () => {
        setGroupBy("");
        setGroups([]);
        props.handleRedefine();
    }

    useEffect(() => {
        setDensitySelected(pref.data?.densitySelected ?? "defaultdensity");
    }, [pref.data?.densitySelected])

    const handleUnGroupVisible = () => {
        props.handleClear(["groupVisible", "expandCloseAll"])
    }

    const optionColumnsDefault: Column = {
        id: false,
        idStatus: false,
        workStatus: false,
        sla_slo: false,
        subject: false,
        workName: false,
        workGroupName: false,
        nameResponsibleUser: false,
        nameUserRequester: false,
        registrationDate: false,
        nameCustomer: false,
        nameBusinessArea: false,
        nameClassification: false,
        statusIcon: false,
        endDate: false,
        nameClassificationGroup: false,
        nameServiceGroup: false,
        nameOpenMode: false,
        urgency: false,
        nameProcess: false,
        nameService: false,
        slaResponseDate: false,
        slaSolutionDate: false,
        workType: false,
        businessUnitDescription: false,
        slaDescription: false,
        workDateBegin: false,
        workDateEnd: false,
        workDateRegister: false,
    };

    useEffect(() => {
        handleSelectedColumns();
    }, [props.optionsGroups])

    const handleSelectedColumns = () => {
        if (props.optionsGroups.length > 0) {

            let teste: Column = props.optionColumns;

            if (textTools.compareObjects(teste, optionColumnsDefault)) {
                props.optionsGroups.map(group => {
                    teste = {
                        ...teste,
                        [group.value]: !props.optionColumns[group.value]
                    }
                });

                props.handleOptionColumns(teste);
            }
        }
    }

    const handleChecked = (option_: any, subMenu: any) => {
        let retorno: boolean = false;

        if (option_.label === "Agrupar por") {
            retorno = props.selectedGroups[subMenu.value];
        }
        else if (option_.label === "Colunas") {
            retorno = props.optionColumns[subMenu.value];
        }
        else if (option_.label === "Densidades") {
            // dispatch({ type: "PREF_UPDATE", payload: { name: "densitySelected", value: subMenu.value } });
            retorno = densitySelected == subMenu.value;
        }

        return retorno;
    }

    const handleColumns = (column: any) => {
        let column_ = props.columns.find(x => x.field === column.value);
        if (column_) column_.hide = !column_.hide;

        const optionColumns_ = { ...props.optionColumns, [column.value]: !props.optionColumns[column.value] };

        if (props.optionColumns[column.value] === true && props.selectedGroups[column.value] === true) {
            handleGroup(column.value);
        }

        props.handleSelectColumns(column);
        props.handleOptionColumns(optionColumns_);
    }

    const handleClickMenu = (option_: any, subMenu: any) => {
        if (option_.label === "Agrupar por") {
            handleGroup(subMenu.value);
        }
        else if (option_.label === "Colunas") {
            handleColumns(subMenu);
        }
        else if (option_.label === "Densidades") {
            handleSelectDensity(subMenu.value);
        }
    }

    const handleSelectDensity = (densityValue: string) => {
        dispatch({ type: "PREF_UPDATE", payload: { name: "densitySelected", value: densityValue } });
    }

    const [marcarTodos, setMarcarTodos] = useState(true)

    const handleMarcarTodos = () => {
        if (marcarTodos) {
            setSelectedRadioRows((props.grouperList) ? props.defaultRows : props.rows);
            setMarcarTodos(false);
        }
        else {
            setSelectedRadioRows([]);
            setMarcarTodos(true);
        }
    }

    const [showExport, setShowExport] = useState<boolean>(false);

    const GroupOptions = () => {
        return (
            <LcTooltip
                trigger={"hover"}
                content={'Mais opções'}
                position={"fullTop"}
            >
                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", fontFamily: "Inter", fontSize: "16px" }}>
                    <Menu menuButton={<div className='lciconlink small'> <i className={"ppi ppi-dots-vertical"} /> </div>}>
                        {
                            props.optionsGroupBy.map((option_, index) => {
                                return (
                                    <SubMenu key={'sbm' + index} style={{ fontFamily: "Inter", fontWeight: "400" }} label={option_.label}>
                                        {
                                            option_.subMenu && option_.subMenu.slice(0, 11).map((subMenu: any, index: number) => {
                                                return (
                                                    <MenuItem
                                                        type="checkbox"
                                                        key={'csbm' + index}
                                                        checked={handleChecked(option_, subMenu)}
                                                        onClick={() => handleClickMenu(option_, subMenu)}
                                                        style={{ fontFamily: "Inter" }}
                                                    >
                                                        {subMenu.label}
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                        {
                                            option_.value !== "density" &&
                                            <>
                                                <MenuDivider />
                                                <MenuItem onClick={() => props.handleOpen(option_.value, option_.subMenu)}>
                                                    <span style={{ fontFamily: "Inter", color: "#342E29", marginLeft: "10px", display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
                                                        Mais
                                                        <div style={{ position: "absolute", right: "0px", }}>
                                                            <LcIcon icon={"ppi ppi-chevron-right"} size={"small"} />
                                                        </div>
                                                    </span>
                                                </MenuItem>
                                            </>
                                        }
                                    </SubMenu>
                                )
                            })
                        }
                        <MenuItem
                            onClick={() => handleUngroup()}
                            style={{ fontFamily: "Inter" }}
                        >
                            <p>Redefinir visualização</p>
                        </MenuItem>
                        <MenuDivider />
                        <MenuItem
                            onClick={() => handleMarcarTodos()}
                            style={{ fontFamily: "Inter" }}
                        >
                            <p> {(marcarTodos) ? 'Marcar todos' : 'Desmarcar todos'}</p>
                        </MenuItem>
                        <MenuDivider />
                        <MenuItem
                            onClick={() => setOnModalLegend(true)}
                            style={{ fontFamily: "Inter" }}
                        >
                            Legenda
                        </MenuItem>
                        <MenuItem
                            onClick={() => setShowExport(!showExport)}
                            style={{ fontFamily: "Inter" }}
                        >
                            Exportar CSV
                        </MenuItem>
                    </Menu>
                </div>
            </LcTooltip>
        )
    }

    const getMinWidth = () => {
        let count = 0;

        Object.values(props.optionColumns).map((field) => {
            if (field === true) {
                count++
            }
        });

        let size = 53;

        Object.keys(props.selectedGroups).map((field) => {
            if (field !== "ungrouped" && props.selectedGroups[field] === true) {
                size += 20;
            }
        });

        if ((!props.rows || (props.rows && props.rows.length === 0))) {
            return { display: 'none' }
        }

        if (menu.showHelper) {
            return { paddingLeft: "53px", display: 'flex', top: (onVisibleModalVinculo) ? "73px" : "0px" } as React.CSSProperties;
        }

        if (count <= 6 && props.selectedGroups.ungrouped) {
            return { minWidth: "100%", paddingLeft: size + "px", display: 'flex', top: (onVisibleModalVinculo) ? "73px" : "0px" } as React.CSSProperties;
        }

        if (!props.selectedGroups.ungrouped) {
            return { display: 'flex', top: (onVisibleModalVinculo) ? "73px" : "0px" } as React.CSSProperties;
        }

        return { paddingLeft: size + "px", display: 'flex', top: (onVisibleModalVinculo) ? "73px" : "0px" } as React.CSSProperties;
    }

    const getExpandedfields = () => {
        if (expandCloseAll.expand) {
            return "close";
        }
        else if (expandCloseAll.close) {
            return "expand";
        }

        if (pref.data?.groupVisible) {
            return "close";
        }

        return "close";
    }

    const handleExpandCloseAll = () => {
        let value;

        if (getExpandedfields() === "expand") {
            value = { expand: true, close: false };
        }
        else {
            value = { expand: false, close: true };
        }

        setExpandCloseAll(value);
        dispatch({ type: "PREF_UPDATE", payload: { name: "expandCloseAll", value: value } });
    }

    const handleIconExpandCloseAll = () => {
        return (getExpandedfields() === "expand") ? "ppi ppi-chevron-down-alt" : "ppi ppi-chevron-up-alt";
    }

    const handleTooltipExpandCloseAll = () => {
        return (getExpandedfields() === "expand") ? "Expandir todos os grupos" : "Fechar todos os grupos";
    }

    const handleReloadTable = () => {
        props.handleReload && props.handleReload();
        setDateReload(new Date());
    }

    const clearValue = () => {
        setDropDown(!dropDown);
        setSearch("")
        props.cleanMessageError(selection);
        // props.handleClearFilters();
    }

    useEffect(() => {
        if (menu.showHelper) {
            setSelectedRadioRows([props.rows[0]]);
        }
    }, [menu.showHelper])

    const functionRadio = (row: any) => {
        let isOnSelectedRowsRadio = selectedRadioRows.length > 0 ? selectedRadioRows.find((r: any) => { return r.id === row.id }) : undefined;

        return (
            <div className="radioCheck">
                <div
                    className="selectable"
                    style={{ marginRight: "5px", marginLeft: "5px" }}
                    onClick={() => {
                        let newRow: any[] = [];

                        if (isOnSelectedRowsRadio) {
                            selectedRadioRows.filter((r: any) => {
                                if (r.id !== row.id) newRow.push(r)
                            });

                            setSelectedRadioRows(newRow);
                        }
                        else {
                            setSelectedRadioRows(arr => [...arr, row]);
                        }
                    }}
                >
                    <i className={`ppi ppi-radiobtn${isOnSelectedRowsRadio ? '-on ' : ' '}`} />
                </div>
            </div>
        )
    }

    const handleLinkClick = (e) => {
        if (e.target.className.includes('ppi') || e.target.className.includes('lciconlink')) {
            e.preventDefault();
            return false
        }

        if (e.ctrlKey) {
            e.preventDefault();
            return false;
        }
    }

    useEffect(() => {
        const openTemplatesAttPref = pref.dataLocal?.openTemplatesAttPref ?? false;
        const item = document.getElementById("dropdownTemplateAtt");

        if (openTemplatesAttPref) {
            if (!item) {
                let el = document.getElementById("templateListSelectionAtt") as any;
                el && el.click();
            }
        }
        else {
            if (item) {
                let el = document.getElementById("templateListSelectionAtt") as any;
                el && el.click();
            }
        }
    }, [pref.dataLocal?.openTemplatesAttPref]);

    const [openIconSearch, setOpenIconSearch] = useState<boolean>(false);

    useEffect(() => {
        const openClickSearchAttPref = pref.dataLocal?.openClickSearchAttPref ?? false;

        if (openClickSearchAttPref) {
            let searchSolicitationAtt: any = document.getElementById('searchSolicitationAtt');

            if (searchSolicitationAtt) {
                searchSolicitationAtt.click();
                setOpenIconSearch(true);

                let searchTextSolicitanteAtt: any = document.getElementById('searchSolicitationTextAtt');

                if (searchTextSolicitanteAtt) {
                    setSearch("teste");

                    let searchDropDown: any = document.getElementById('searchDropDownAtt');
                    searchDropDown && searchDropDown.click();
                }
            }
        }
        else {
            if (openIconSearch) {
                let searchSolicitationAtt: any = document.getElementById('searchSolicitationAtt');
                searchSolicitationAtt && searchSolicitationAtt.click();

                setOpenIconSearch(false);
            }
        }
    }, [pref.dataLocal?.openClickSearchAttPref])

    useEffect(() => {
        if (menu.showHelper) {
            const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
            setOnVisibleModalVinculo((openVincularPref) ? true : false);
        }
    }, [pref.dataLocal?.openVincularPref]);

    useEffect(() => {
        setDropDown(true);
        setOnVisibleModalVinculo(false);
    }, [menu.showHelper]);

    const [hideAllTooltips, setHideAllTooltips] = useState<boolean>(false);

    return (
        <div
            id="lcdti"
            className="HHAttendantTable"
            style={{ height: (!menu.fullScreen) ? props.height || '100%' : 'calc(100vh - 250px)' }}
            onMouseEnter={() => setHideAllTooltips(false)}
            onMouseLeave={() => setHideAllTooltips(true)}
        >
            <Modal width='55%' visible={onModalLegend} close={() => setOnModalLegend(false)} title={"Como entender um chamado HeyHo!"} >
                <img style={{ width: "100%" }} src={imgLegend} alt="Legenda" />
            </Modal>
            <ExportList visible={showExport} setVisible={setShowExport} list={props.rows} columns={props.columns} />
            <div className="topbar"
                style={{
                    position: (menu.fullScreen === true) ? "fixed" : "initial",
                    top: (menu.fullScreen === true) ? "25px" : "",
                    right: (menu.fullScreen === true) ? "230px" : ""
                }}
            >
                <div className="functions">
                    {
                        props.functions &&
                        <div>
                            {
                                props.functions.map((func, index) => {
                                    return (
                                        <LcIconLink
                                            tooltipPosition={index === 0 ? 'right' : undefined}
                                            disabled={func.disabled || false}
                                            key={index}
                                            icon={func.icon}
                                            tooltip={func.tooltip}
                                            onClick={() => { func.func(selectedRows) }}
                                        />
                                    )
                                })
                            }
                        </div>
                    }
                    {
                        props.functionGeneric &&
                        <div>
                            {
                                props.functionGeneric.map((func, index) => {
                                    if (func.isSelection) {
                                        let listaTemplate: Period[] = [];

                                        if (menu.showHelper) {
                                            listaTemplate = templateHelper;
                                        }
                                        else {
                                            if (func.selection?.contents) {
                                                listaTemplate = func.selection?.contents;
                                            }
                                        }

                                        return (
                                            <>
                                                {
                                                    <LcDropDown
                                                        style={{ margin: "15px 10px 0px -10px" }}
                                                        element={
                                                            <span className="select-period">
                                                                <LcIconLink
                                                                    icon={func.icon}
                                                                    size={func.size || "small"}
                                                                    tooltip={func.tooltip}
                                                                    tooltipPosition={func.tooltipPosition}
                                                                    id={"templateListSelectionAtt"}
                                                                />
                                                            </span>
                                                        }>
                                                        <>
                                                            {
                                                                (func.selection?.contents && func.selection?.contents.length > 0)
                                                                    // listaTemplate.length > 0
                                                                    ? <div className={"dropdownTemplateAtt"} style={{ width: "max-content", maxWidth: "15rem" }}>
                                                                        {
                                                                            func.selection?.contents.slice(0, 7).map((item, index) => {
                                                                                // listaTemplate.slice(0, 7).map((item, index) => {
                                                                                return <span key={index} className="item" onClick={() => onChangeSelection(item)}>{item.nameTemplate}</span>
                                                                            })
                                                                        }
                                                                        <>
                                                                            <hr />

                                                                            {/* <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between" }}>
                                                                                <span className="item"
                                                                                    onClick={() => onChangeSelection("mais")}
                                                                                > Mais templates </span>
                                                                                <LcIconLink icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                            </div> */}

                                                                            <div 
                                                                                className='optionTemplate'
                                                                                style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between" }}>
                                                                                <span className="item" onClick={() => onChangeSelection("editar")}> Gerenciar templates </span>
                                                                                <LcIconLink icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                            </div>
                                                                        </>
                                                                    </div>
                                                                    : <span className="item"> Sem templates salvos </span>
                                                            }
                                                        </>
                                                    </LcDropDown>
                                                }
                                            </>
                                        )
                                    }

                                    if (func.isVincular) {
                                        return (
                                            <LcIconLink
                                                icon={"ppi ppi-flow-merge"}
                                                tooltip={func.tooltip}
                                                onClick={() => setOnVisibleModalVinculo(!onVisibleModalVinculo)}
                                                activedAfterClick={onVisibleModalVinculo}
                                            />
                                        )
                                    }

                                    if (func.isFilter) {
                                        return (
                                            <>
                                                <LcIconLink icon={"ppi ppi-search"} tooltip="Pesquisar Chamado" onClick={() => setDropDown(!dropDown)} id={"searchSolicitationAtt"} activedAfterClick={!dropDown} />
                                                <div id='search' className={(!dropDown) ? "active" : ""}>
                                                    <div style={{ marginBottom: "-30px", whiteSpace: "nowrap" }}>
                                                        <LcDropDown
                                                            // width={"fit-content"}
                                                            width={"500px"}
                                                            id={"searchDropDownAtt"}
                                                            element={
                                                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                                    <input
                                                                        id={"searchSolicitationTextAtt"}
                                                                        type="text"
                                                                        className={"searchText"}
                                                                        ref={searchInput}
                                                                        onChange={searchValue}
                                                                        value={search.replace("> ", "")}
                                                                        autoComplete={"false"}
                                                                        onKeyDown={(event) => { if (event.key === "Enter") onChangeSelectionFilter(templateMais) }}
                                                                        placeholder={"Pesquise pelo número ou assunto do chamado"}
                                                                    />
                                                                    <LcIconLink icon={"ppi ppi-x"} tooltip="Fechar" size='small' onClick={() => clearValue()} />
                                                                </div>
                                                            }
                                                            onEnterClose={true}
                                                            trigger={(menu.showHelper) ? "click" : "keyPress"}
                                                        >
                                                            {
                                                                func.isFilterCampo?.isLoadingContents
                                                                    ? <span className="item">Carregando...</span>
                                                                    : <div style={{ maxHeight: "75vh" }}>
                                                                        {
                                                                            func.isFilterCampo?.contents.length === 0
                                                                                ? <span className="item">Nenhum resultado encontrado</span>
                                                                                : <>
                                                                                    {
                                                                                        func.isFilterCampo?.contents.slice(0, 7).map((p, i) => {
                                                                                            var result_ = '';
                                                                                            let resultHtml;

                                                                                            if (typeof p.label === 'string' && typeof search === 'string') {
                                                                                                var searchMask = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                                                                                                searchMask = escapeRegExp(searchMask);
                                                                                                var regEx = new RegExp(searchMask, "ig");
                                                                                                let replaceMask = `<strong>${searchMask}</strong>`

                                                                                                result_ = p.label.replace(/[\u0300-\u036f]/g, "");
                                                                                                result_ = textTools.cleanTagEmailParse(result_);
                                                                                                resultHtml = result_.replace(regEx, replaceMask)
                                                                                            }

                                                                                            return (
                                                                                                <span key={i} className="item" onClick={() => history.push(`Attendance/${p.record ? p.record.id : "0"}`)}>
                                                                                                    {Parse(resultHtml)}
                                                                                                </span>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                    {
                                                                                        func.isFilterCampo?.contents && func.isFilterCampo?.contents.length > 0 &&
                                                                                        <>
                                                                                            <hr />
                                                                                            <span
                                                                                                className="item"
                                                                                                onClick={() => onChangeSelectionFilter(templateMais)}
                                                                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}
                                                                                            >
                                                                                                Mais resultados
                                                                                                <LcIconLink icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                                            </span>
                                                                                        </>
                                                                                    }
                                                                                </>
                                                                        }
                                                                    </div>
                                                            }
                                                        </LcDropDown>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }

                                    if (func.iconDisabled) {
                                        if (func.iconDisabled.disabled && func.iconDisabled.disabled === true) {
                                            if (!menu.fullScreen) {

                                                return (
                                                    <LcIcon
                                                        id={func.id}
                                                        icon={func.icon}
                                                        tooltipPosition={index === 0 ? 'right' : undefined}
                                                        key={index}
                                                        tooltip={func.iconDisabled.tooltip}
                                                        color={func.iconDisabled.color}
                                                    />
                                                )
                                            }
                                        }
                                        else {
                                            if (selectedRadioRows && selectedRadioRows.length > 0) {

                                                return (
                                                    <LcIconLink
                                                        id={func.id}
                                                        tooltipPosition={index === 0 ? 'right' : undefined}
                                                        key={index}
                                                        icon={func.icon}
                                                        tooltip={func.tooltip}
                                                        onClick={func.func}
                                                        size={func.size}
                                                    />
                                                )
                                            }
                                            else {

                                                return (
                                                    <LcIcon
                                                        id={func.id}
                                                        icon={func.icon}
                                                        tooltipPosition={index === 2 ? 'right' : undefined}
                                                        key={index}
                                                        tooltip={func.iconDisabled.tooltip}
                                                        color={func.iconDisabled.color}
                                                    />
                                                )
                                            }
                                        }
                                    }
                                    else {
                                        return (
                                            <LcIconLink
                                                id={func.id}
                                                tooltipPosition={index === 0 ? 'right' : undefined}
                                                key={index}
                                                icon={`${func.icon} ${func.changeColorAfterClick && pref.data?.appliedFilter ? 'text-warning' : ''}`}
                                                tooltip={func.tooltip}
                                                onClick={func.func}
                                                size={func.size}
                                                activedAfterClick={func.activedAfterClick}
                                            />
                                        )
                                    }
                                })
                            }
                        </div>
                    }
                    {
                        props.filter &&
                        <LcIconLink
                            icon={`ppi ppi-filter ${asFilter ? 'text-warning' : ''}`}
                            onClick={() => { setModalFilterVisible(true) }}
                            tooltip="Filtro" />
                    }
                    {
                        // !menu.fullScreen &&
                        <GroupOptions />
                    }
                    {
                        props.handleReload &&
                        <>
                            <LcIconLink icon={"ppi ppi-refresh"}
                                onClick={() => handleReloadTable()}
                                tooltip="Atualizar"
                            />
                            {
                                dateReload && !menu.fullScreen &&
                                <span style={{ fontSize: "12px", color: "#8B90A3", fontStyle: 'normal', lineHeight: '150%', marginLeft: '10px' }}>{`Atualizado ${moment(dateReload).fromNow()}`}</span>
                            }
                        </>
                    }
                </div>
                {
                    props.messageErrorGroup !== '' &&
                    <span style={{
                        display: 'flex',
                        alignItems: 'baseline',
                        textAlign: 'start',
                        color: 'red',
                        fontWeight: '600',
                        fontSize: '12px',
                        position: 'relative',
                        top: '11px',
                        zIndex: '5',
                        marginBottom: '10px'
                    }}>{props.messageErrorGroup}</span>
                }
            </div>

            {
                props.openFilters &&
                <AttendanceFilters
                    handleClearFilters={props.handleClearFilters}
                    currentFilter={props.currentFilter}
                    handleFilters={props.handleFilters}
                    filterDefault={props.filterDefault}
                />
            }

            <div className='connectionHeaderBody' style={{ overflowX: (props.rows.length > 0) ? "scroll" : "hidden", justifyContent: (props.rows.length === 0) ? "center" : "space-between" }}>
                <InputLink
                    onVisibleModalVinculo={onVisibleModalVinculo}
                    setOnVisibleModalVinculo={setOnVisibleModalVinculo}
                    selectedRadioRows={selectedRadioRows}
                    setSelectedRadioRows={setSelectedRadioRows}
                    rows={props.rows}
                />

                <div className="header" style={getMinWidth()}>
                    {
                        !menu.showHelper && props.selectedGroups.ungrouped === false &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                overflow: "visible",
                                padding: (props.grouperList.length === 1)
                                    ? '0px 16px'
                                    : ((props.grouperList.length < 3)
                                        ? `0px ${props.grouperList.length * 13}px`
                                        : `0px ${props.grouperList.length * 12}px`)
                            }}>
                            <LcIconLink
                                icon={handleIconExpandCloseAll()}
                                onClick={() => handleExpandCloseAll()}
                                tooltip={handleTooltipExpandCloseAll()}
                                tooltipPosition={"fullRight"}
                            />
                        </div>
                    }
                    {
                        props.onSelectChange &&
                        <div className="selectable" >
                            <i className={`ppi ppi-checkbox${selectedRows.length > 0 ? '-on text-warning' : ' text-grey'}`} onClick={() => {
                                (selectedRows.length > 0)
                                    ? setSelectedRows([])
                                    : setSelectedRows(props.rows)
                            }} />
                        </div>
                    }
                    {
                        props.columns.filter(v => v.hide !== true).map((c: any, i: number) => {
                            return (
                                <div
                                    className={`cell  ${props.onSortChange && c.sort !== false ? 'sortable' : ''} ${sort?.column === c.field ? 'text-link' : ''}${c.align || ''}`}
                                    style={{ width: c.width, display: 'flex', alignItems: 'center' }}
                                    key={i}
                                    onClick={() => { c.sort !== false && props.onSortChange && handleSort(c.field) }}
                                >
                                    <span> {(c.field === "statusIcon") ? "" : c.headerName} </span>
                                    {
                                        c.headerName && sort && sort.column === c.field &&
                                        <i className={`ppi ppi-arrow-${sort.direction === 'asc' ? 'down' : 'up'}`} style={{ marginLeft: "3px" }} />
                                    }
                                </div>
                            )
                        })
                    }
                    {
                        props.functionsRow &&
                        <div className="cell" />
                    }
                </div>
                <div className="body" style={{ width: (props.rows.length === 0) ? "100%" : "", maxHeight: props.grouperList.length > 0 ? `${windowHeight - 175}px` : props.openFilters ? `${windowHeight - 386}px` : `${windowHeight - 155}px`, height: onVisibleModalVinculo ? `${windowHeight - 228}px` : `${windowHeight - 155}px` }}>
                    {
                        props.rows && props.rows.map((row: any, iRow: number) => {
                            if (row instanceof Array) {
                                const groupType = props.grouperList[0].key;
                                const group = dynamicTableService.getGroup(row, groupType);

                                return (
                                    <BodyGroup
                                        rows={row}
                                        groupType={groupType}
                                        group={group}
                                        grouperList={props.grouperList}
                                        dynamicTableService={dynamicTableService}
                                        selectedRadioRows={selectedRadioRows}
                                        handleMouseMove={handleMouseMove}
                                        tooltipObject={tooltipObject}
                                        status={props.status}
                                        densitySelected={densitySelected}
                                        columns={props.columns}
                                        fontSize={props.fontSize}
                                        handleLinkClick={handleLinkClick}
                                        functionsRow={props.functionsRow}
                                        rowClick={props.rowClick}
                                        handleRowClick={handleRowClick}
                                        functionRadio={functionRadio}
                                        getStatusRow={getStatusRow}
                                        expandCloseAll={expandCloseAll}
                                    />
                                )
                            }
                            else {
                                return (
                                    <div
                                        id={row.id}
                                        className={`${(selectedRadioRows.includes(row)) ? "selectedRow" : ""} row`}
                                        style={{ borderLeft: props.status && "5px solid " + getStatusRow(props.status(row)), borderRight: props.status && "5px solid #fff" }}
                                    >
                                        {/* <div
                                            className="status"
                                        // style={{ backgroundColor: props.status && getStatusRow(props.status(row)) }}
                                        /> */}
                                        {
                                            functionRadio(row)
                                        }
                                        <div
                                            className={`cells ${densitySelected}`}
                                            key={iRow}
                                            data-tip={iRow}
                                            data-for={iRow}
                                        >
                                            <HHDetailTooltip
                                                tooltipId={iRow + ''}
                                                fields={tooltipData}
                                                searchExpandedFields={props.tootipPropeties?.searchExpandedFields}
                                                rowId={selectedRowId}
                                                mousePosition={mousePosition}
                                                attendant={true}
                                                hide={!hideTooltip}
                                                hideAllTooltips={hideAllTooltips}
                                                {...props.tootipPropeties?.optionsProprities}
                                            />
                                            {
                                                props.columns.filter(v => v.hide !== true).map((col: any, iCol: number) => {
                                                    return (
                                                        <a href={"/Attendance/" + row.id} className={`cell ${densitySelected} ${props.fontSize || ''} ${col.align || ''}`}
                                                            style={{ textDecoration: 'none', color: 'black' }} onClick={(e) => { handleLinkClick(e) }}
                                                        >
                                                            <div
                                                                key={iCol}
                                                                className={`cell ${densitySelected} ${props.fontSize || ''} ${col.align || ''} ${col.class ? col.class : ''}`}
                                                                style={{
                                                                    width: col.width,
                                                                    overflow: col.overflow,
                                                                    cursor: "pointer"
                                                                }}
                                                                onMouseOver={(e) => handleMouseMove(e, row.id, iCol)}
                                                                // onMouseOutCapture={() => setHideTooltip(true)}
                                                                onClick={(e) => handleRowClick(row, iCol, e)}
                                                            >
                                                                {
                                                                    !col.renderCell
                                                                        ? <> {row[col.field]} </>
                                                                        : col.renderCell(row)
                                                                }
                                                            </div>
                                                        </a>
                                                    )
                                                })
                                            }
                                        </div>

                                        <div className="functions">
                                            {
                                                props.functionsRow &&
                                                <LcDropDown element={<LcIconLink tooltip="Agrupamentos" icon="ppi ppi-dots-vertical" size="small" />} position="right">
                                                    {
                                                        props.functionsRow.map((f, i) => {
                                                            if (!f.hidden || !f.hidden(row)) {
                                                                let disabled = (f.disabled && f.disabled(row)) || false;

                                                                return (
                                                                    <div
                                                                        key={i}
                                                                        className={`item${disabled ? ' disabled' : ''}`}
                                                                        onClick={() => { !disabled && f.func(row) }}> {f.label} </div>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </LcDropDown>
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                    {
                        props.loading &&
                        <div className="loader" >
                            <i className="ppi ppi-refresh text-warning" />&nbsp;Carregando...
                        </div>
                    }
                    {/* {
                        props.size > clientHeight && (props.rows && props.rows.length < props.size) &&
                            !inView ?
                                    <div className="loader">
                                        <div ref={ref}>
                                            <i className="ppi ppi-refresh text-warning" /> &nbsp;Carregando... 
                                        </div>
                                    </div>
                                :
                                    <></>
                    } */}
                    {
                        !props.loading && (!props.rows || (props.rows && props.rows.length === 0)) &&
                        <div className="centralized">
                            <i className="ppi ppi-information-circle" />
                            <span> Você não possui nenhum chamado. Clique no botão + para criar um. </span>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default HHAttendantTable;